import { Button } from "../components/ui/button";
import { Card } from "../components/ui/card";
import { LogIn, ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const navigate = useNavigate();

  const handleGoogleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center px-4"
      style={{ backgroundColor: "#F6F8F3" }}
    >
      <Card
        className="p-10 max-w-md w-full shadow-xl"
        style={{ backgroundColor: "#FFFFFF", borderRadius: "24px" }}
        data-testid="login-card"
      >
        <div className="text-center space-y-6">
          <h1
            className="text-3xl font-black tracking-tight"
            style={{ color: "#1A2118" }}
            data-testid="login-title"
          >
            Admin pieslēgšanās
          </h1>
          <p style={{ color: "#475545" }}>
            Pieslēdzieties ar Google kontu, lai piekļūtu admin panelim
          </p>

          <Button
            onClick={handleGoogleLogin}
            data-testid="google-login-button"
            className="w-full text-white text-base py-6 rounded-full font-bold hover:scale-[1.02] transition-transform duration-200"
            style={{ backgroundColor: "#27A64C" }}
          >
            <LogIn className="mr-2 h-5 w-5" />
            Pieslēgties ar Google
          </Button>

          <Button
            onClick={() => navigate("/")}
            data-testid="back-to-home-from-login"
            variant="ghost"
            className="w-full rounded-full"
            style={{ color: "#475545" }}
          >
            <ArrowLeft className="mr-2 h-4 w-4" />
            Atpakaļ uz sākumlapu
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default Login;
